export const ROUTE_HOME = '/'
export const ROUTE_ASSISTANT = '/assistant'
export const ROUTE_BRANDS = '/brands'
export const ROUTE_BRAND_DETAILS = '/brands/:brandSlug'
export const ROUTE_SETTINGS = '/settings'

export const getBrandDetailsPath = (brandSlug) =>
  `${ROUTE_BRANDS}/${encodeURIComponent(brandSlug)}`
